module.exports = __webpack_public_path__ + "img/new_logo_sem_slogan_white.1df9d525.svg";